<template>
	<div>
		<!-- 进度条 -->
		<div 
			class="progressBar" 
			v-if="quanxian && quanxian.showSchedule == 1" 
			:style="{ width: `${percentage}%` }">
		</div>
		<div>
			<NoticePage v-if="isShowNotice" :notice="notice" :title="data.title" @answerSubmitClick="answerSubmitClick" :isPc="true"></NoticePage>
			<div
				v-else-if="!isShowNotice"
				class="content"
				:style="{
					backgroundImage: `url(${bandingstyle.appearance.bgImg})`,
					backgroundRepeat: bandingstyle.appearance.bgLocation,
					backgroundColor: bandingstyle.appearance.bgColor
				}"
			>
				<div class="previewFunction" v-if="isBank">
					<div class="print" title="打印" v-print="print"></div>
					<div class="derive" title="导出" @click="exportData"></div>
				</div>
				<div class="body" 
					id="printArea" :style="{ backgroundColor: `rgba(255,255,255,${bandingstyle.appearance.bgOpacity / 100})` }">
					<div class="pageHeader" v-if="bandingstyle.appearance.headerState == 1">
						<div class="pageHeaderText" :style="{ backgroundColor: bandingstyle.appearance.headerBgcolor }" v-if="bandingstyle.appearance.headerType == 0">
							<div
								:style="{
									fontSize: bandingstyle.appearance.titleSize + 'px',
									color: bandingstyle.appearance.headerColor,
									fontWeight: bandingstyle.appearance.headerBold,
									fontStyle: bandingstyle.appearance.headerItalic,
									textDecoration: bandingstyle.appearance.headerUnderline,
									textAlign: bandingstyle.appearance.headerAlign
								}"
							>
								{{ bandingstyle.appearance.headerContent }}
							</div>
						</div>

						<div v-else-if="bandingstyle.appearance.headerType == 1"><img style="width: 100%; height: auto" :src="bandingstyle.appearance.headerImg" /></div>
					</div>
					<div class="logo" v-if="bandingstyle.appearance.logoSet" :style="{ textAlign: bandingstyle.appearance.logoLocation }">
						<img class="logo-img" :src="bandingstyle.appearance.logoSet" />
					</div>
					<div class="ques_box">
						<div class="header" v-if="page == 1">
							<p
								class="title"
								v-if="bandingstyle.appearance.displayTitle != 0"
								:style="{
									fontSize: bandingstyle.appearance.fontTitleSize + 'px',
									color: bandingstyle.appearance.fontTitleColor,
									fontWeight: bandingstyle.appearance.fontTitleBold,
									fontStyle: bandingstyle.appearance.fontTitleItalic,
									textDecoration: bandingstyle.appearance.fontTitleUnderline
								}"
								v-html="data.title"
							></p>
							<p
								class="welcome-words"
								v-if="bandingstyle.appearance.displayWelcome != 0"
								:style="{
									fontSize: bandingstyle.appearance.fontWelcomeSize + 'px',
									color: bandingstyle.appearance.fontWelcomeColor,
									fontWeight: bandingstyle.appearance.fontWelcomeBold,
									fontStyle: bandingstyle.appearance.fontWelcomeItalic,
									textDecoration: bandingstyle.appearance.fontWelcomeUnderline
								}"
								v-html="data.depict"
							></p>
							<div class="info" v-if="quanxian">
								<p class="info_num">
									<span>共{{ data.quesCount }}题</span>
									<span>共{{ data.totalScore }}分</span>
								</p>
								<div class="info_time_box"></div>
							</div>
						</div>
						<template v-if="list.length > 0">
							<div v-for="(item, index) in list" :key="index">
								<!-- 基本信息 -->
								<div :name="`name${item.qid}`" v-if="item.questionsTypeId == 600" class="basic_info ques_list">
									<div class="ques_list_item">
										<p
											class="title"
											:class="{ required: item.mustanswer }"
											:style="{
												fontSize: bandingstyle.appearance.fontStemSize + 'px',
												color: bandingstyle.appearance.fontStemColor,
												fontWeight: bandingstyle.appearance.fontStemBold,
												fontStyle: bandingstyle.appearance.fontStemItalic,
												textDecoration: bandingstyle.appearance.fontStemUnderline
											}"
										>
											<span v-html="item.questionsName"></span>
										</p>
										<div class="input_box">
											<el-input
												:class="{ input__err: item.validate }"
												class="item-input"
												resize="none"
												type="textarea"
												:rows="item.inputHeight == '小' ? 1 : item.inputHeight == '中' ? 2 : 3"
												v-model="item.userAnswer"
											></el-input>
											<div v-show="item.validate" class="form-item__error">{{ item.validateMsg }}</div>
										</div>
									</div>
								</div>
								<!-- 单选题 -->
								<SelectType
									v-else-if="item.questionsTypeId == 100 || item.questionsTypeId == 101 || item.questionsTypeId == 102"
									:data="item"
									:bandingstyle="bandingstyle"
									:showTitleNum="quanxian ? quanxian.showTitleNum : 1"
									@userAnswerChange="userAnswerChange"
								></SelectType>

								<ShortAnswer
									v-else-if="item.questionsTypeId == 204 || item.questionsTypeId == 206 || item.questionsTypeId == 207 || item.questionsTypeId == 208"
									:data="item"
									:bandingstyle="bandingstyle"
									:showTitleNum="quanxian ? quanxian.showTitleNum : 1"
								></ShortAnswer>

								<!-- 绘图 -->
								<div :name="`name${item.qid}`" v-if="item.questionsTypeId == 209" class="basic_info ques_list">
									<div class=" ques_list_item">
										<div
											class="title"
											:class="{ required: item.mustanswer }"
											:style="{
												fontSize: bandingstyle.appearance.fontStemSize + 'px',
												color: bandingstyle.appearance.fontStemColor,
												fontWeight: bandingstyle.appearance.fontStemBold,
												fontStyle: bandingstyle.appearance.fontStemItalic,
												textDecoration: bandingstyle.appearance.fontStemUnderline
											}"
										>
											<span v-if="quanxian ? quanxian.showTitleNum : 1">{{ item.quesIndex + 1 }}、</span>
											<p v-html="item.questionsName"></p>
										</div>
										<div class="input_box">
											<div class="signature">
												<canvas v-show="!item.userAnswer" :class="`canvasId${item.qid}`" />
												<img v-show="item.userAnswer" :src="item.userAnswer" alt="" />
												<div class="save-signature">
													<span>完成签名后，请点击【完成】按钮</span>
													<div>
														<el-button size="mini" v-show="!item.userAnswer" @click="saveCanvasId(item)">完成</el-button>
														<el-button size="mini" v-show="item.userAnswer" @click="clearCanvasId(item)">清除</el-button>
													</div>
												</div>
											</div>
											<div v-show="item.validate" class="form-item__error">{{ item.validateMsg }}</div>
										</div>
									</div>
								</div>

								<!-- 上传文件 -->
								<div :name="`name${item.qid}`" v-if="item.questionsTypeId == 210" class="basic_info ques_list">
									<div class=" ques_list_item">
										<div
											class="title"
											:class="{ required: item.mustanswer }"
											:style="{
												fontSize: bandingstyle.appearance.fontStemSize + 'px',
												color: bandingstyle.appearance.fontStemColor,
												fontWeight: bandingstyle.appearance.fontStemBold,
												fontStyle: bandingstyle.appearance.fontStemItalic,
												textDecoration: bandingstyle.appearance.fontStemUnderline
											}"
										>
											<span v-if="quanxian ? quanxian.showTitleNum : 1">{{ item.quesIndex + 1 }}、</span>
											<p v-html="item.questionsName"></p>
										</div>
										<div class="input_box">
											<el-upload
												class="upload-demo"
												:accept="item.limitFormat"
												:action="$config.service.uploadApi"
												:multiple="item.maxfilesNum == 1 ? false : true"
												:on-success="(response, file, fileList) => handleSuccess(response, file, fileList, item)"
												:before-upload="file => beforeAvatarUpload(file, item)"
												:data="QiniuData"
												:on-remove="(file, fileList) => handleRemove(file, fileList, item)"
												:on-exceed="(file, fileList) => handleExceed(file, fileList, item)"
												:limit="parseInt(item.maxfilesNum)"
												:file-list="item.fileList"
												drag
											>
												<i class="el-icon-upload"></i>
												<div class="el-upload__text">
													将文件拖到此处，或
													<em>点击上传</em>
												</div>
												<div class="el-upload__tip">最多{{ item.maxfilesNum }}个，单个文件大小不超过{{ item.fileSize }}MB</div>
											</el-upload>
											<div v-show="item.validate" class="form-item__error">{{ item.validateMsg }}</div>
										</div>
									</div>
								</div>
								<!-- 段落描述 -->
								<div
									:name="`name${item.qid}`"
									v-else-if="item.questionsTypeId == 401"
									class="test_question list"
									:style="{
										fontSize: bandingstyle.appearance.fontStemSize + 'px',
										color: bandingstyle.appearance.fontStemColor,
										fontWeight: bandingstyle.appearance.fontStemBold,
										fontStyle: bandingstyle.appearance.fontStemItalic,
										textDecoration: bandingstyle.appearance.fontStemUnderline
									}"
								>
									<p class="title" v-html="item.questionsName"></p>
								</div>
							</div>
						</template>

						<div class="no-more" v-else-if="list.length == 0">这里什么也没有~</div>
						<div class="btn-box">
							<div>
								<el-button-group v-if="lists.length > 1" class="page-btn">
									<el-button size="medium" :disabled="page == 1" @click="lastPage" type="primary">上一页</el-button>
									<el-button size="medium" :disabled="page == lists.length" @click="nextPage" type="primary">下一页</el-button>
								</el-button-group>
							</div>

							<el-button v-if="page == this.lists.length && !isBank" @click="submit" size="medium" type="primary" :disabled="list.length == 0">
								{{ bandingstyle.appearance.buttonContent ? bandingstyle.appearance.buttonContent : '提交' }}
							</el-button>
						</div>
					</div>
					
					<!-- <div v-if="path != '/examAppearance' && path != '/examPreview' && !isShowNotice" class="answerSheet content_right"> -->
					<div v-if="!isShowNotice" class="answerSheet content_right">
						<el-card class="box-card answerSheet" shadow="never" :body-style="{ padding: '0px' }">
							<div slot="header" class="clearfix header">
								<span class="title">答题卡</span>
								<!-- <div class="progress_box" v-if="quanxian.showSchedule == 1"> -->
									<!-- <span>进度条：</span> -->
									<!-- <el-progress class="progress" :percentage="percentage" :color="customColor"></el-progress> -->
								<!-- </div> -->
								<span v-show="quanxian.openReverseTimeStatus == 1" class="count-down itemC">
									倒计时：
									<CountDown ref="countDown" :endTime="endTime" :endText="'结束了'" @examendChange="examendChange"></CountDown>
								</span>
							</div>

							<div class="answerSheet-body">
								<template v-for="(item, index) in data.questionsList">
									<div
										class="item_list"
										v-if="item.questionsTypeId != 402 && item.questionsTypeId != 404"
										:id="`answer-sheet${item.oid}`"
										:class="{
											selected: (item.userAnswer && item.userAnswer != '') || (item.userAnswerArr && item.userAnswerArr.length > 0)
										}"
										@click="goAnchor(`name${item.qid}`, item.qid)"
										:key="index"
									>
										{{ item.quesIndex || item.quesIndex == 0 ? item.quesIndex + 1 : '' }}
									</div>
								</template>
							</div>

							<div class="clearfix footer-box itemC">
								<span class="sign1 itemC">已答 {{ answeredNum }}</span>
								<span class="sign2 itemC">未答 {{ unansweredNum }}</span>
							</div>
						</el-card>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import CountDown from '@/components/countDown';
import SelectType from './selectType.vue';
import ShortAnswer from './shortAnswer.vue';
import NoticePage from './noticePage.vue';
import SignaturePad from 'signature_pad';
import { v1 as UUID } from 'uuid';
import { mapState } from 'vuex';
import { Check } from '@/util/checkValue/CheckValue.js';

export default {
	components: {
		SelectType,
		ShortAnswer,
		CountDown,
		NoticePage
	},
	name: 'appearancePC',
	props: {
		bandingstyle: {},
		data: {},
		path: {
			type: String,
			default: ''
		},
		quanxian: {
			type: Object,
			default:() => {
				return {
					"id": "af5234a93bd24893b3f5ccd8f331a27b",
					"wjTitle": "<p style=\"text-align: center;\"><span style=\"font-size: 20px\"><strong><span style=\"color: #10ab97;\">问卷回显</span></strong></span></p>",
					"appearanceId": "",
					"content": "感谢您能抽出几分钟时间来参加本次答题，现在我们就马上开始吧！",
					"wjType": "问卷类型",
					"startTime": "",
					"endTime": "",
					"createId": "fbb957c37ff345bc9705877bf7bcaaee",
					"modifyId": "",
					"mechanismId": "",
					"modifyTime": "2025-10-23 10:08:14",
					"createTime": "2025-10-22 11:36:28",
					"delTag": 0,
					"useNumber": 1,
					"isOpen": 0,
					"handleMode": "",
					"versionNumber": "",
					"state": 2,
					"wxLimit": 0,
					"wxLimitNumber": 1,
					"pcLimit": 0,
					"pcLimitNumber": 1,
					"ipLimit": 0,
					"ipLimitNumber": 1,
					"startUpPassword": 0,
					"startUpPasswordNumber": "",
					"limitPhone": 0,
					"onlyEmail": 0,
					"setStartEndTime": 0,
					"onlyWx": 0,
					"recordWxUser": 0,
					"setAnswerLimit": 0,
					"setAnswerLimitNumber": 0,
					"ifQuote": 0,
					"quoteNumber": 0,
					"quoteQuestionnaireId": "",
					"isRandom": 0,
					"pictureAddress": "defaulttemplate.png",
					"rejectReason": "",
					"newMsgtoWX": 0,
					"newMsgtoEmail": 0,
					"email": "",
					"collectionMethod": 0,
					"grantMethod": 0,
					"shareLogo": 0,
					"prohibitWXShare": 0,
					"bindWX": "",
					"bindEmail": "",
					"breakpointAnswer": 0,
					"ifAnswerDataLimit": 0,
					"answerDataLimit": "",
					"ifPageAnswerTime": 0,
					"pageAnswerTime": "",
					"ifScreeningPage": 0,
					"ifQuota": 0,
					"ifRuleFilter": 0,
					"ifAllowStatistics": 0,
					"ifDisplayShare": 1,
					"ifWechatRedPacket": 0,
					"ifCustomDraw": 0,
					"wxLimitFreq": 0,
					"pcLimitFreq": 0,
					"ipLimitFreq": 0,
					"ifCustomJump": 0,
					"customJump": 0,
					"manyThanks": "您的答卷已提交，感谢您的参与！",
					"skipUrl": "",
					"shareSeoIndex": 0,
					"hideLogo": "",
					"subjectColor": "#0080ff",
					"phoneUnique": 0,
					"earlyTerminationTAG": "非常抱歉，您不适合本次调查的人群条件，感谢您的参与",
					"issueTime": "2025-10-23 10:08:15",
					"ifanswerPlaza": 0,
					"versions": 8,
					"randomSurveyId": "7145562614",
					"isBanModifyPhone": 0,
					"isHidePhone": 0,
					"accessprotModifySample": 0,
					"isEnableCallControl": 0,
					"callControlSum": 0,
					"isEnableAppointmentMinuteHint": "",
					"appointmentMinuteSum": 0,
					"isPutSampleReadIntervalTime": "",
					"putSampleReadIntervalTimeSum": "",
					"pretaskcode": "",
					"dialsearchtype": 1,
					"rate": 0.15,
					"isEntry": 0,
					"isStaging": 0,
					"isEnableSible": 0,
					"sibleScoringFormula": "",
					"finallyTime": "",
					"isEnableSibleScoringFormula": 0,
					"validDay": 0,
					"randomJson": "",
					"copyrightConfigContent": "",
					"copyrightConfig": 0,
					"wxshareContent": "大家一起来参与吧！",
					"wxsharePicture": "aixuelogo.png",
					"wxshareTitle": "<p style=\"text-align: center;\"><span style=\"font-size: 20px\"><strong><span style=\"color: #10ab97;\">问卷标题</span></strong></span></p>"
				}
			}
		},
		isBank: {
			type: Boolean,
			default: false // true 题库预览
		},
		isPreviewPc: {
		    type: Number,
		    default: 0 // 1 手机 2 pc
		},
		// percentage:{
		//     type: Number,
		//     default: 0
		// },
	},
	data() {
		return {
			//打印
			print: {
				id: 'printArea',
				popTitle: '打印', // 打印配置页上方标题
				extraHead: '', // 最上方的头部文字，附加在head标签上的额外标签,使用逗号分隔
				preview: '', // 是否启动预览模式，默认是false（开启预览模式，可以先预览后打印）
				previewTitle: '', // 打印预览的标题（开启预览模式后出现）,
				previewPrintBtnLabel: '', // 打印预览的标题的下方按钮文本，点击可进入打印（开启预览模式后出现）
				zIndex: '', // 预览的窗口的z-index，默认是 20002（此值要高一些，这涉及到预览模式是否显示在最上面）
				clickMounted: value => {
					// 去掉 点击展开
					let titleid = document.getElementsByClassName('content');
					console.log(titleid[0].style.width);
					// titleid[0].style.width = '1200px'
					// titleid[0].style.marginLeft = '600px'
					//     for (var i = 0; i < titleid.length; i++) {
					//       titleid[i].style.display = 'none';
					//     }

					//     this.groupJson.forEach((item, index) => {
					//       // console.log(item)
					//       if (item.ifSetPrint) {
					//         if (item.ifSetPrint == true) {
					//           let printId = document.getElementById(item.id);
					//           console.log(printId);
					//           if (printId != null) {
					//             printId.style.display = 'block';
					//           }
					//         } else {
					//           let printId = document.getElementById(item.id);
					//           console.log(printId);
					//           if (printId != null) {
					//             printId.style.display = 'none';
					//           }
					//         }
					//       } else {
					//         let printId = document.getElementById(item.id);
					//         console.log(printId);
					//         if (printId != null) {
					//           printId.style.display = 'none';
					//         }
					//       }
					//     });
				}, // 点击打印按钮的回调函数
				previewBeforeOpenCallback: value => {
					console.log('预览窗口打开之前的callback');
				}, // 预览窗口打开之前的callback（开启预览模式调用）
				previewOpenCallback: value => {
					console.log('预览窗口打开之后的callback');
				}, // 预览窗口打开之后的callback（开启预览模式调用）
				beforeOpenCallback: value => {
					console.log('开启打印前的回调事件');
				}, // 开启打印前的回调事件
				openCallback: value => {
					console.log('调用打印之后的回调事件');
				}, // 调用打印之后的回调事件
				closeCallback: value => {
					let titleid = document.getElementsByClassName('content');
					console.log(titleid[0].style.width);
					// titleid[0].style.width = '650px'
					// titleid[0].style.marginLeft = '0px'
					// let titleid = document.getElementsByClassName('titleHeader');
					// for (var i = 0; i < titleid.length; i++) {
					//   titleid[i].style.display = 'block';
					//   titleid[i].style.padding = '0px 20px';
					//   titleid[i].style.height = '50px';
					//   titleid[i].style.backgroundColor = '#f4f5f9';
					//   titleid[i].style.lineHeight = '50px';
					//   titleid[i].style.display = 'flex';
					//   titleid[i].style.justifyContent = 'space-between';
					//   titleid[i].style.marginBottom = '20px';
					// }
					// console.log('关闭打印的回调事件');
					// this.groupJson.forEach(item => {
					//   let printId = document.getElementById(item.id);
					//   if (printId != null) {
					//     printId.style.display = 'block';
					//   }
					// });
				}, // 关闭打印的回调事件（无法确定点击的是确认还是取消）
				url: '',
				standard: '',
				extraCss: ''
			},
			//打印  end
			// customColor: '#50E6A7',
			input: '',
			radio: '',
			checkList: [],
			textarea: '',
			exam: {},
			endTime: '',
			lists: [],
			list: [],
			page: 1,
			activeQid: '',
			percentage: 0,
			id: '',
			SignaturePad: null,
			config: {
				penColor: '#000000', //笔刷颜色
				minWidth: 1, //最小宽度
				maxWidth: 3,
				backgroundColor: '#f7f8fa'
			},
			QiniuData: {
				biz: 'upDataKs',
				data: {}
			},
			answeredNum: 0,
			unansweredNum: 0,
			isShowNotice: false,
			notice: {}
		};
	},
	computed: {
		...mapState(['headers'])
	},
	watch: {
		activeQid(newV) {
			// console.log(newV)
			this.lists.forEach((info, index) => {
				info.forEach((item, i) => {
					if (newV == item.qid) {
						this.page = index + 1;
						this.list = info;
						// console.log(this.page)
					}
				});
			});
		},
		lists: {
			handler(newV, oldV) {
				let count = 0;
				this.answeredNum = 0;
				this.unansweredNum = 0;
				this.data.questionsList.forEach((info, index) => {
					if (info.questionsTypeId != 401 && info.questionsTypeId != 402 && info.questionsTypeId != 404) {
						count++;
						if (info.userAnswer && info.userAnswer != '') {
							// console.log(info.userAnswer)
							this.answeredNum++;
						} else if (info.userAnswerArr && info.userAnswerArr.length > 0) {
							this.answeredNum++;
						} else {
							this.unansweredNum++;
						}
					}
				});
				this.percentage = parseInt((this.answeredNum / count) * 100);

				if (this.quanxian && this.quanxian.saveLastContent == 1) {
					localStorage.setItem(this.id, JSON.stringify(this.data.questionsList));
					// console.log(this.data.questionsList)
				}
			},
			deep: true
			// immediate: true
		}
	},
	created() {
		console.log('this.quanxian :>> ', this.quanxian);
		// sessionStorage.removeItem("examId")
		this.id = this.getQueryStringhash('id');
		// console.log(this.data)
		// 权限start
		// 获取考试结束倒计时
		if (this.quanxian && this.quanxian.examEndStatus == 1) {
			this.endTime = parseInt(new Date(this.quanxian.examEndTime).getTime());
			this.endTime = this.endTime.toString();
		}
		// 权限end

		let arr = [];
		if (this.data.questionsList && this.data.questionsList.length > 0) {
			this.data.questionsList = this.data.questionsList.filter((info, index) => {
				if (info.questionsTypeId == 600) {
					if (!info.userAnswer) {
						info.userAnswer = info.placeholder;
					}
				} else if (info.questionsTypeId == 501) {
					// 考前须知
					this.isShowNotice = true
					this.notice = info
				}
				if (info.questionsTypeId == 402 || info.questionsTypeId == 404) {
					this.lists.push(arr);
					arr = [];
				} else {
					arr.push(info);
				}
				if (index == this.data.questionsList.length - 1) {
					this.lists.push(arr);
				}
				return info.questionsTypeId != 501
			});
			console.log(this.data.questionsList)
			console.log(this.lists)
			this.lists = this.lists.filter((info) => {
				
				return info.length > 0
			})
			this.list = this.lists[0];
			if (!this.isShowNotice) {
				this.list.forEach(info => {
					if (info.questionsTypeId == 209) {
						this.$nextTick(() => {
							this.getCanvas(info.qid, info);
						});
					}
				});
			}
		}
	},
	methods: {    
		changeCountDown(){
			this.$refs.countDown.stopCountDown()
		},
		answerSubmitClick() {
            this.isShowNotice = false
            this.list.forEach(info => {
				if (info.questionsTypeId == 209) {
					this.$nextTick(() => {
						this.getCanvas(info.qid, info);
					});
				}
			});
        },
		// 当试题存在逻辑，用户答题后触发
		userAnswerChange(data) {
			// 选项关联 试题是否显示
			this.displayLogic(data);
		},
		displayLogic(data) {
			let { questionsList } = this.data;
			for (let j = 0; j < questionsList.length; j++) {
				// 选项关联
				if (data.associated && data.associated.indexOf(questionsList[j].qid) !== -1) {
					// 获取当前试题已选的option
					let newOptionList = this.getOption(data);
					let copiedNewOptionList = newOptionList.map(option => ({ ...option }));
					// 保留不是当前试题的option
					let actionOptionList = questionsList[j].optionList.filter(info => data.qid != info.qid);
					questionsList[j].optionList = [...copiedNewOptionList, ...actionOptionList];

					// 如果被关联的试题 已答并选项被清除 清除答案
					this.clearAnswer(questionsList[j]);
				}
			}
		},
		
		// 获取该题已选的option
		getOption(data) {
			return data.optionList.filter(op => {
				if (data.userAnswer && data.userAnswer == op.oid) {
					op.qid = data.qid;
					op.inputValue = '';
					return op;
				}
				if (data.userAnswerArr && data.userAnswerArr.indexOf(op.oid) !== -1) {
					op.qid = data.qid;
					op.inputValue = '';
					return op;
				}
			});
		},
		
		// 被关联的试题 清除answer
		clearAnswer(question) {
			console.log('question :>> ', question);
			if (question.userAnswerArr) {
				let oidArr = question.optionList.map(val => val.oid);
				let i = question.userAnswerArr.findIndex(val => oidArr.indexOf(val) == -1);
				if (i !== -1) question.userAnswerArr.splice(i, 1);
			}
			if (question.userAnswer) {
				let i = question.optionList.findIndex(val => question.userAnswer == val.oid);
				// console.log(i)
				if (i === -1) question.userAnswer = '';
			}
		},
		exportData() {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.exportKsWrod}`,
				method: 'POST',
				data: {
					surveyId: this.id
				},
				cb(res) {
					console.log('查询全部全部字段对照', res);
					if (res.code == 0) {
						that.popUpPrompt()
					} else {
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		popUpPrompt() {
			this.$notify({
				dangerouslyUseHTMLString: true,
				message: `${this.$t('DataRecycling.DataPreparationInProgress')} 
							<a href="#" class="notify-link" id="my-download-link">
								<span style="color: blue;">${this.$t('DataRecycling.MyDownload')}</span>
							</a> 
							${this.$t('DataRecycling.CanViewProgress')}`
			});
			this.$nextTick(() => {
				const link = document.querySelector('#my-download-link');
				if (link) {
					link.addEventListener('click', (e) => {
						e.preventDefault(); // 阻止默认的链接跳转
						this.$router.push('/MyProject'); // 使用 Vue Router 跳转
					});
				}
			});
		},
		beforeAvatarUpload(file, item) {
			let size = file.size < 1024 * 1024 * item.fileSize;
			const allowedExtensions = item.limitFormat.toLowerCase().split(',');
			const fileExtension = '.' + file.name.split('.').pop().toLowerCase();
			const isFormatValid = allowedExtensions.includes(fileExtension);
			if (!size) {
                item.validate = true
                item.validateMsg = `上传文件大小不能超过 ${item.fileSize}MB，请重新选择文件！`
				return size;
			} else if (!isFormatValid) {
                item.validate = true
                item.validateMsg = `文件格式不正确！仅支持 ${item.limitFormat} 格式，请重新选择文件！`
				return isFormatValid;
			} else {
                item.validate = false
                item.validateMsg = ''
				this.QiniuData.data = file;
			}
		},
		handleSuccess(res, file, fileList, item) {
			if (typeof item.userAnswerArr == 'string') {
				item.userAnswerArr = []
			}
			item.userAnswerArr.push(res.message);
			item.fileList = fileList;
		},
		handleRemove(file, fileList, item) {
			if (file.status != 'success') return
			item.userAnswerArr = [];
			fileList.forEach(info => {
				item.userAnswerArr.push(info.response.message);
			});
			item.fileList = fileList;
		},
		handleExceed(file, fileList, item) {
			if (file.length > item.maxfilesNum || fileList.length === item.maxfilesNum) {
                item.validate = true
                item.validateMsg = `最多只允许上传${item.maxfilesNum}个文件`
			} else {
                item.validate = false
                item.validateMsg = ''
            }
		},
		getCanvas(qid, info) {
			var canvas = document.querySelector(`.canvasId${qid}`);
			info.signaturePad = new SignaturePad(canvas, this.config);
			canvas.height = 190;
			canvas.width = 438;
		},
		saveCanvasId(item) {
			if (item.signaturePad.isEmpty() == false) {
				item.userAnswer = item.signaturePad.toDataURL();
			} else {
				item.userAnswer = '';
			}
		},
		clearCanvasId(item) {
			item.signaturePad.clear();
			item.userAnswer = '';
		},
		verification() {
			let result = false;
			for (let i in this.list) {
				let otherArr = [ 100, 101, 102 ]
				if (otherArr.indexOf(this.list[i].questionsTypeId) != -1) {
					for(let j in this.list[i].optionList) {
						if (this.list[i].optionList[j].notAnswer && this.list[i].optionList[j].inputValue == ''){
							continue;
						}
						console.log('this.list[i].optionList[j] :>> ', this.list[i].optionList[j]);
						if (this.list[i].optionList[j].format || this.list[i].optionList[j].haveInput) {
							if (((this.list[i].questionsTypeId == 100 || this.list[i].questionsTypeId == 102) && this.list[i].userAnswer == this.list[i].optionList[j].oid)||
								this.list[i].questionsTypeId == 101 && this.list[i].userAnswerArr.indexOf(this.list[i].optionList[j].oid) != -1
							) {
								console.log('this.list[i].questionsTypeId', this.list[i].questionsTypeId)
								this.list[i].optionList[j].userAnswer = this.list[i].optionList[j].inputValue
								result = Check(this.list[i].optionList[j],this.list[i]);
								console.log('result :>> ', result);
								if (result) {
									this.goAnchor(`name${this.list[i].qid}`, this.list[i].qid);
									return result;
								}
							}
						}
					}
				}
				if (this.list[i].mustanswer) {
					if (this.list[i].questionsTypeId == 101 || this.list[i].questionsTypeId == 210) {
						if (this.list[i].userAnswerArr.length == 0) {
							this.list[i].validate = true;
							this.goAnchor(`name${this.list[i].qid}`, this.list[i].qid);
							return (result = true);
						} else {
							this.list[i].validate = false;
						}
					} else if (this.list[i].questionsTypeId == 207 || this.list[i].questionsTypeId == 208) {
						this.list[i].optionList.forEach((info) => {
							info.validate = false
						})
						for (let j in this.list[i].optionList) {
							if (this.list[i].optionList[j].mustanswer) {
								if (!this.list[i].optionList[j].userAnswer) {
									this.list[i].optionList[j].validate = true;
									this.list[i].optionList[j].validateMsg = '请输入内容';
									this.goAnchor(`name${this.list[i].qid}`, this.list[i].qid);
									return (result = true);
								} else {
									result = Check(this.list[i].optionList[j]);
									if (result) {
										this.goAnchor(`name${this.list[i].qid}`, this.list[i].qid);
										return result;
									}
								}
							} else {
								if (this.list[i].optionList[j].userAnswer) {
									result = Check(this.list[i].optionList[j]);
									if (result) {
										this.goAnchor(`name${this.list[i].qid}`, this.list[i].qid);
										return result;
									}
								} else {
									this.list[i].optionList[j].validate = false;
								}
							}
						}
					} else if (this.list[i].questionsTypeId == 204 || this.list[i].questionsTypeId == 206 || this.list[i].questionsTypeId == 600) {
						if (this.list[i].userAnswer == '') {
							this.list[i].validate = true;
							this.list[i].validateMsg = '请输入内容';
							this.goAnchor(`name${this.list[i].qid}`, this.list[i].qid);
							return (result = true);
						} else {
							result = Check(this.list[i]);
							if (result) {
								this.goAnchor(`name${this.list[i].qid}`, this.list[i].qid);
								return result;
							}
						}
					} else if (this.list[i].questionsTypeId == 100 || this.list[i].questionsTypeId == 102 || this.list[i].questionsTypeId == 209) {
						if (this.list[i].userAnswer == '') {
							this.list[i].validate = true;
							this.goAnchor(`name${this.list[i].qid}`, this.list[i].qid);
							return (result = true);
						} else {
							this.list[i].validate = false;
						}
					}
				} else {
					if (this.list[i].questionsTypeId == 207 || this.list[i].questionsTypeId == 208) {
						this.list[i].optionList.forEach((info) => {
							info.validate = false
						})
						for (let j in this.list[i].optionList) {
							if (this.list[i].optionList[j].userAnswer == '') {
								this.list[i].optionList[j].validate = true;
								this.goAnchor(`name${this.list[i].qid}`, this.list[i].qid);
								return (result = true);
							} else {
								result = Check(this.list[i].optionList[j]);
								if (result) {
									this.list[i].optionList[j].validate = true;
									this.goAnchor(`name${this.list[i].qid}`, this.list[i].qid);
									return true;
								}
							}
						}
					} else if (this.list[i].questionsTypeId == 204 || this.list[i].questionsTypeId == 206 || this.list[i].questionsTypeId == 600) {
						if (this.list[i].userAnswer != '') {
							result = Check(this.list[i]);
							if (result) {
								this.goAnchor(`name${this.list[i].qid}`, this.list[i].qid);
								this.list[i].validate = true;
								return result;
							}
						} else {
							this.list[i].validate = false;
							result = false;
						}
					}
				}
			}
			return result;
		},
		submit() {
			// console.log(this.data.questionsList)
			// 验证

			if (this.verification() == false) {
				this.$emit('submit');
			}
		},
		lastPage() {
			if (this.page > 1) {
				this.page--;
				this.list = this.lists[this.page - 1];
				if (this.list.length > 0) {
					this.list.forEach(info => {
						if (info.questionsTypeId == 209) {
							this.$nextTick(() => {
								this.getCanvas(info.qid, info);
							});
						}
					});
				}
				this.scrollToTop()
			}
		},
		nextPage() {
			if (this.page < this.lists.length) {
				// 验证
				if (this.verification() == false) {
					this.page++;
					this.list = this.lists[this.page - 1];
					if (this.list.length > 0) {
						this.list.forEach(info => {
							if (info.questionsTypeId == 209) {
								this.$nextTick(() => {
									this.getCanvas(info.qid, info);
								});
							}
						});
					}
					this.scrollToTop()
				}
			}
		},
		scrollToTop() {
			document.documentElement.scrollTop = 0
			document.body.scrollTop = 0
		},
		goAnchor(aname, qid) {
			this.activeQid = qid;
			this.$nextTick(() => {
				let selector = `div[name=${aname}]`;
				var anchor = this.$el.querySelector(selector);
				if (anchor) {
					anchor.scrollIntoView({ block: 'center', behavior: 'smooth' });
				}
			});
		},
		examendChange() {
			// console.log('考试结束了')
			this.examEnded = true;
			// 是否开启考试结束后n没有新操作就强制交卷
			if (this.quanxian.overtimeForceSubmit == 1 && this.examEnded == true) {
				this.$emit('addEventListener', 1);
			}
		},
		// 获取参数 带#
		getQueryStringhash(key) {
			let after = window.location.hash.split('?')[1];
			if (after) {
				let reg = new RegExp('(^|&)' + key + '=([^&]*)(&|$)');
				let r = after.match(reg);
				if (r != null) {
					return decodeURIComponent(r[2]);
				} else {
					return null;
				}
			}
		}
	},
};
</script>
<style lang="scss" scoped>
/* 大屏幕（大桌面显示器，小于等于 1452px） */
@media (max-width: 1452px) {
  .content_right {
    width: 148px !important;
  }
}
.progressBar{
	height: 3px;
	background-color: #0080FF;
	position: fixed;
	top: 0;
	left: 0;
	z-index: 9999;
}
.test_question {
	.title {
		word-break: break-all;
		display: flex;
	}
}
.content {
 	min-height: 100vh;
	padding: 50px 20px 30px 20px;
	background-color: #fff;
	box-sizing: border-box;
	position: relative;
	background-attachment: fixed;
    background-size: cover;
	.previewFunction {
		width: 60px;
		height: 130px;
		background-color: #ffffff;
		position: absolute;
		top: 0px;
		left: -70px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: space-around;
		.print {
			width: 24px;
			height: 27px;
			background-image: url('../../../assets/print.png');
			background-size: 100% 100%;
			cursor: pointer;
		}
		.derive {
			width: 24px;
			height: 22px;
			background-image: url('../../../assets/derive.png');
			background-size: 100% 100%;
			cursor: pointer;
		}
	}
	.body {
		width: 900px;
		margin: auto;
		border-radius: 10px;
		.logo {
			position: relative;
			top: 10px;
			right: 0;
			left: 0;
			bottom: 0;
			z-index: 1000;
			.logo-img {
				max-height: 140px;
				max-width: 100%;
			}
		}

		.ques_box {
			padding: 20px 50px 50px 50px;
			box-sizing: border-box;
			// font-weight: bold;
			font-style: normal;
			font-size: 16px;
			.header {
				font-size: 20px;
				border-bottom: 3px solid blue;
				padding: 20px 0 20px 0;
				margin-bottom: 33px;
				.welcome-words {
					font-size: 16px;
					color: #666666;
					margin-top: 20px;
				}
				.info {
					display: flex;
					justify-content: space-between;
					align-items: center;
					font-weight: 100;
					font-size: 16px;
					margin-top: 20px;
					.info_num span + span {
						display: inline-block;
						margin-left: 10px;
					}

					.info_time_box {
						display: flex;
						align-items: center;
						// .progress_box{
						//     display: flex;
						//     align-items: center;
						//     margin-left: 20px;
						//     .progress{
						//         width: 150px;
						//     }
						// }
					}
				}
				.title {
					word-break: break-all;
					display: flex;
				}
			}
			.list {
				margin-bottom: 50px;
			}
			.ques_list {
				.ques_list_item {
					margin-top: 10px;
					margin-bottom: 50px;
					.input_box {
						margin-top: 10px;
					}
				}
				.title {
					// width: 100px;
					word-break: break-all;
					display: flex;
				}
				.input {
					width: 220px;
				}
			}
		}
	}

	.pageHeaderText {
		background-color: #eff4fe;
		text-align: left;
		font-size: 16px;
		color: #666666;
		padding: 12px 40px;
	}
}
.required::before {
	content: '*';
	color: #f56c6c;
	margin-right: 4px;
}
.selected {
	border: 1px solid #bae4f6 !important;
	background: #e8fbff;
	color: #2196f3;
}
.itemC {
	display: flex;
	align-items: center;
}
.btn-box {
	display: flex;
	justify-content: space-between;
	align-items: center;
}
.no-more {
	font-size: 16px;
	color: #a1a1a1;
	margin-bottom: 20px;
	text-align: center;
}
.content_right {
	position: fixed;
    top: 200px;
    transform: translateX(940px);
    transition: all .3s linear;
    width: 207px;
    z-index: 1500;
	.answerSheet {
		.header {
			/deep/.el-card__header {
				padding: 12px 20px;
			}
			.title {
				font-size: 15px;
			}
			.title::before {
				content: '';
				width: 2px;
				height: 12px;
				background: blue;
				display: inline-block;
				margin-right: 6px;
			}
			.count-down,
			.progress_box {
				font-size: 14px;
				margin-top: 10px;
			}
		}

		.answerSheet-body {
			padding: 12px 20px;
			display: flex;
			flex-wrap: wrap;
			.item_list {
				margin: 4px 2px;
				font-size: 12px;
				line-height: 27px;
				text-align: center;
				width: 27px;
				height: 27px;
				border-radius: 50%;
				border: 1px solid #ccc;
				cursor: pointer;
			}
		}
		.btn-box {
			text-align: center;
			padding: 20px 0;
			border-top: 1px solid #ebeef5;
		}
		.footer-box {
			padding: 12px 20px;
			border-top: 1px solid #ebeef5;
			box-sizing: border-box;
			font-size: 12px;
			.sign1 {
				margin-right: 20px;
			}
			.sign1::before {
				content: '';
				display: inline-block;
				width: 10px;
				height: 10px;
				border-radius: 50%;
				border: 1px solid rgb(186, 228, 246);
				background: rgb(232, 251, 255);
				margin-right: 5px;
			}
			.sign2::before {
				content: '';
				display: inline-block;
				width: 10px;
				height: 10px;
				border-radius: 50%;
				border: 1px solid #ccc;
				background: #fff;
				margin-right: 5px;
			}
		}
	}
}

/deep/.input__err > .el-input__inner {
	border-color: #f56c6c;
}
/deep/.input__err .el-textarea__inner {
	border-color: #f56c6c;
}
.input_box {
	.signature {
		width: 438px;
		border: 1px solid rgba(0, 0, 0, 0.1);
		margin: 20px 0;
		.save-signature {
			width: 100%;
			height: 40px;
			line-height: 40px;
			background: #fff;
			border-top: 1px solid rgba(0, 0, 0, 0.1);
			color: #aaa;
			font-size: 12px;
			padding: 0 10px;
			box-sizing: border-box;
			display: flex;
			justify-content: space-between;
		}
	}
}
</style>
<style lang="scss">
.input_box {
	position: relative;

	.form-item__error {
		color: #f56c6c;
		font-size: 12px;
		line-height: 1;
		padding-top: 4px;
		position: absolute;
		// top: 92px;
		// left: 228px;
	}
	/deep/.input__err .el-input__inner {
		border-color: #f56c6c;
	}
	/deep/.input__err .el-textarea__inner {
		border-color: #f56c6c;
	}
}
</style>
